import z from "zod";

export const ENV_SCHEMA = z.object({
  VITE_CLIENT_ID: z.guid(),
  VITE_CKO_PK: z.string(),
  VITE_DEV_USER_ID: z
    .guid()
    .optional()
    .or(z.literal("").transform(() => undefined)),
  VITE_ROUTE_SERVER: z.url().transform((v) => new URL(v).origin),
});

export const env = ENV_SCHEMA.parse(import.meta.env);
